export default "__VITE_ASSET__BcheSxb$__"